import { MARKETING_URL } from './config'

export function marketingUrl(path: string, locale: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${MARKETING_URL}/${locale}${cleanPath}`
}
